"use strict";var _a,_b,__importDefault=this&&this.__importDefault||function(e){return e&&e.__esModule?e:{default:e}};Object.defineProperty(exports,"__esModule",{value:!0}),exports.EffectCard=void 0;const react_1=__importDefault(require("react")),styled_1=__importDefault(require("../utils/styled")),filters_1=require("../utils/filters"),Card=(0,styled_1.default)("div")`
  display: flex;
  flex-direction: column;
  flex-grow: 0;
  width: calc(33% - 16px);
  gap: 8px;
  cursor: pointer;
`,Title=(0,styled_1.default)("span")`
  text-align: center;
`,Content=(0,styled_1.default)("div")`
  position: relative;
  border-radius: 10px;
  box-sizing: border-box;
  height: 90px;
`,Image=(0,styled_1.default)("img")`
  height: 100%;
  width: 100%;
  object-fit: cover;
  border-radius: 10px;
`,ActiveBorder=(0,styled_1.default)("div")`
  left: -4px;
  top: -4px;
  bottom: -4px;
  right: -4px;
  display: flex;
  position: absolute;
  border-radius: 15px;
  padding: 2px;
  transition: 0.2s border;
  border: 2px solid ${e=>e.active?"white":"transparent"};
`,EffectCard=({title:e,imageSrc:t,effect:r,onClick:a,active:l})=>{const i=getImageComponent(r);return react_1.default.createElement(Card,{onClick:a},react_1.default.createElement(Content,null,react_1.default.createElement(ActiveBorder,{active:l}),react_1.default.createElement(i,{src:t})),react_1.default.createElement(Title,null,e))};exports.EffectCard=EffectCard;const SepiaImage=(0,styled_1.default)(Image)`
  filter: sepia(1);
`,GrayscaleImage=(0,styled_1.default)(Image)`
  filter: grayscale(1);
`,WarmImage=(0,styled_1.default)(Image)`
  filter: ${null===(_a=(0,filters_1.shapeFilterToCSS)(filters_1.Effects.warm))||void 0===_a?void 0:_a.filter};
`,ColdImage=e=>{const{html:t,filter:r}=(0,filters_1.shapeFilterToCSS)(filters_1.Effects.cold);return react_1.default.createElement(react_1.default.Fragment,null,react_1.default.createElement("div",{style:{display:"none"},dangerouslySetInnerHTML:{__html:t}}),react_1.default.createElement(Image,Object.assign({style:{filter:r}},e)))},NaturalImage=(0,styled_1.default)(Image)`
  filter: ${null===(_b=(0,filters_1.shapeFilterToCSS)(filters_1.Effects.natural))||void 0===_b?void 0:_b.filter};
`,getImageComponent=e=>{switch(e){case filters_1.Effects.sepia:return SepiaImage;case filters_1.Effects.grayscale:return GrayscaleImage;case filters_1.Effects.warm:return WarmImage;case filters_1.Effects.cold:return ColdImage;case filters_1.Effects.natural:return NaturalImage;default:return Image}};